<template>
  <div class="personal-data summary-content">
    <ShowSummaryPersonalData :customer="getCustomer">
      <template #txtBefore><slot name="txtBeforePersonalDataWrapper"></slot></template>
      <template #labelSalutation><slot name="lblSalutationWrapper"></slot></template>
      <template #labelFirstName><slot name="lblFirstNameWrapper"></slot></template>
      <template #labelLastName><slot name="lblLastNameWrapper"></slot></template>
      <template #labelStreetNumber><slot name="lblStreetNumberWrapper"></slot></template>
      <template #labelZipCity><slot name="lblZipCityWrapper"></slot></template>
      <template #labelSupplement><slot name="lblSupplementWrapper"></slot></template>
      <template #labelBirthDate><slot name="lblBirthDateWrapper"></slot></template>
      <template #labelEmail><slot name="lblEmailWrapper"></slot></template>
    </ShowSummaryPersonalData>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import ShowSummaryPersonalData from './ShowSummaryPersonalData.vue'

export default {
  name: 'ShowSuccessPersonalData',
  computed: {
    ...mapGetters('activation/personalData', ['personal', 'address', 'additional']),
    getCustomer() {
      return {
        salutation: this.personal.gender,
        firstName: this.personal.firstName,
        lastName: this.personal.lastName,
        birthDate: this.personal.birthDate,
        email: this.additional.email,
        address: this.address
      }
    }
  },
  components: {
    ShowSummaryPersonalData
  }
}
</script>
